import { useCallback } from 'react'

import styled from '@emotion/styled'
import type { TFunction } from 'i18next'

import { ArcadeButtonLink, spacing } from '@cash-design-system/react'
import type { LinkAdapterProps } from '@cash-web/support/ui-components'

interface MoreResultsButtonProps<T> extends LinkAdapterProps<T> {
  query: string
  t: TFunction
}

const ButtonContainer = styled.div`
  margin: ${spacing.s} auto ${spacing.xl};
`

const MoreResultsButton = <T,>({ query, t }: MoreResultsButtonProps<T>) => {
  const encodedQuery = encodeURIComponent(query)
  const route = `/search#${encodedQuery}`
  const label = t('More results', { context: 'search view more results button' })

  const pathSegments = window.location.pathname.split('/').filter(Boolean)
  const basePath = pathSegments[0] ? `/${pathSegments[0]}` : '' // e.g., `/help` or `/support`
  const fullRoute = `${basePath}${route}`

  const handleClick = useCallback(
    (event: { preventDefault: () => void }) => {
      event.preventDefault()

      // push new route
      window.history.pushState({}, '', fullRoute)

      // reload page
      window.location.reload()
    },
    [fullRoute]
  )

  return (
    <ButtonContainer>
      <ArcadeButtonLink aria-label={label} href={fullRoute} onClick={handleClick} prominence="standard">
        {label}
      </ArcadeButtonLink>
    </ButtonContainer>
  )
}

export default MoreResultsButton
